import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { KidsCategorySearchClientManager } from "../ClientManagers/Searching/CategorySearchClientManager";
import { KidsTitlesSearchClientManager } from "../ClientManagers/Searching/KidsTitlesSearchClientManager";
import { KidsSeriesSearchClientManager } from "../ClientManagers/Searching/SeriesSearchClientManager";
import { LS2KIDS_CONSTANTS } from "../constants";

/**
 * tlc.ls2kids.managers.searchDatabaseManager
 */
export const KidsSearchDatabaseManager = function () {
	var myDatabases = {},
		currentDatabase = "",
		defaultPageSize = 10,
		ls2kidsTitlesSearch = null,
		ls2kidsCategorySearch = null,
		ls2kidsSeriesSearch = null,
		configs = [];

	var init = function () {
		setupTitleSearchDB();
		setupCategorySearchDB();
		setupSeriesSearchDB();
		currentDatabase = LS2KIDS_CONSTANTS.searchDatabases.ls2pac;
	};

	var setupTitleSearchDB = function () {
		myDatabases[LS2KIDS_CONSTANTS.searchDatabases.ls2pac] = {
			databaseKey: LS2KIDS_CONSTANTS.searchDatabases.ls2pac,
			targetAudience: LS2KIDS_CONSTANTS.targetAudience,
			searchedFromKids: true,
			isDefault: true,
			requiresLogin: false,
			changeLayoutSupported: false,
			hasFacets: false,
			startsAtZero: true,
			isBatchable: false,
			hasSaveSearch: false,
			supportsAvailability: true,
			supportsTags: false,
			supportsReviews: false,
			supportsSort: false,
			fullDetailsTemplate: "tmpl/details/detailsPageView.html",
			sortingData: {
				sortOptions:[],
				sortKey: ''
			},
			detailViews: []
		};

		ls2kidsTitlesSearch = new KidsTitlesSearchClientManager({
			restUrl: LS2KIDS_CONSTANTS.restUrls.search,
			pageSize: defaultPageSize,
			databaseConfig: myDatabases[ LS2KIDS_CONSTANTS.searchDatabases.ls2pac ],
			searchDatabaseManager: KidsSearchDatabaseManager
		});

		myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key].searchClientManager = ls2kidsTitlesSearch;
		configs.push(myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key]);
	};

	var setupCategorySearchDB = function() {
		var ls2KidsCategoryConfig = myDatabases[ LS2KIDS_CONSTANTS.searchDatabases.category ] = {
			databaseKey: "category",
			searchedFromKids: true,
			targetAudience: LS2KIDS_CONSTANTS.targetAudience,
			isDefault: false,
			requiresLogin:           false,
			startsAtZero:            true,
			isBatchable:             false,
			hasSaveSearch:           false,
			supportsAvailability:    true,
			supportsSort:            false,
			fullDetailsTemplate:     "tmpl/details/detailsPageView.html",
			sortingData: {
				sortOptions:[],
				sortKey:    ''
			},
			detailViews: [],
			hasAudienceControl: false
		};

		ls2kidsCategorySearch = new KidsCategorySearchClientManager({
			restUrl: LS2KIDS_CONSTANTS.restUrls.categorySearch,
			pageSize: defaultPageSize,
			databaseConfig: ls2KidsCategoryConfig,
			searchDatabaseManager: KidsSearchDatabaseManager
		});

		myDatabases[ LS2KIDS_CONSTANTS.searchDatabases.category ].searchClientManager = ls2kidsCategorySearch;

		configs.push(myDatabases[ LS2KIDS_CONSTANTS.searchDatabases.category ]);
	};

	var setupSeriesSearchDB = function() {
		var ls2KidsSeriesConfig = myDatabases[ LS2KIDS_CONSTANTS.searchDatabases.series ] = {
			databaseKey: "series",
			searchedFromKids: true,
			targetAudience: LS2KIDS_CONSTANTS.targetAudience,
			isDefault: false,
			requiresLogin:           false,
			startsAtZero:            true,
			isBatchable:             false,
			hasSaveSearch:           false,
			supportsAvailability:    true,
			supportsSort:            false,
			fullDetailsTemplate:     "tmpl/details/detailsPageView.html",
			sortingData: {
				sortOptions:[],
				sortKey:    ''
			},
			detailViews: []
		};

		ls2kidsSeriesSearch = new KidsSeriesSearchClientManager({
			restUrl: LS2KIDS_CONSTANTS.restUrls.seriesSearch,
			pageSize: defaultPageSize,
			databaseConfig: ls2KidsSeriesConfig,
			searchDatabaseManager: KidsSearchDatabaseManager
		});

		myDatabases[ LS2KIDS_CONSTANTS.searchDatabases.series ].searchClientManager = ls2kidsSeriesSearch;

		configs.push(myDatabases[ LS2KIDS_CONSTANTS.searchDatabases.series ]);
	};

	return {
		setPageSize: function( pageSize ) {
			ls2kidsTitlesSearch.setPageSize( pageSize );
			ls2kidsCategorySearch.setPageSize( pageSize );
			ls2kidsSeriesSearch.setPageSize( pageSize );
		},
		setupSearchDatabases: function () {
			init();
		},
		getDatabaseConfigs: function() {
			return configs;
		},
		getCurrentDatabaseConfig: function() {
			TLCLogger.log("getCurrentDatabaseConfig", myDatabases, currentDatabase);
			return myDatabases[currentDatabase];
		},
		getCurrentDatabaseKey: function() {
			return currentDatabase;
		},
		setCurrentDatabaseKey: function( databaseKey ) {
			currentDatabase = databaseKey;
		},
		isCurrentDatabase: function( databaseKey ) {
			return ( databaseKey == currentDatabase );
		},
		getResourcebyId: function( id ) {
			return myDatabases[ currentDatabase ].searchClientManager.getResourceById( id );
		}
	};
}();

// TODO test need to override LS2Pac SearchDatabaseManager
// if( ! tlc.ls2pac.managers ) { tlc.ls2pac.managers = {}; }
// tlc.ls2pac.managers.searchDatabaseManager = KidsSearchDatabaseManager;

